module.exports = __webpack_public_path__ + "img/upload tugas.69372d44.jpg";